import React, { useEffect } from 'react';
import { useAppState } from '@unfold/provider';
import { StoriesWrapper, ListWrapper } from './styled';
import { Typography } from '@unfold/typography';
import { useStoriesState } from '../store';
import { Story } from './story';
import { IStory } from '../common/types';

export const Stories: React.FC = () => {
  const [state] = useAppState();
  const [StoriesState, actions] = useStoriesState();

  useEffect(() => {
    actions.load();
  }, []);
  return (
    <StoriesWrapper>
      <Typography variant="H700">{state.user?.brand_name}</Typography>
      <ListWrapper>
        {StoriesState.loading ? (
          <div>Loading...</div>
        ) : (
          StoriesState.stories.map((story: IStory) => (
            <Story key={story.uuid} story={story} />
          ))
        )}
      </ListWrapper>
    </StoriesWrapper>
  );
};
